import React, { Component } from 'react';
import MiniCurtain from '../heatmap/MiniCurtain';
import { tcap } from '../../../utils/translate';
import flipInvert from '../../../utils/flipInvert';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ANIMATION_DURATION } from './Popup';

class Prompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false,
      show: true,
      transform: '',
      isClosing: false,
      isOpening: false,
      isTargetOpen: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const isClosing = prevState.isTargetOpen && !nextProps.isTargetOpen;
    const isOpening = !prevState.isTargetOpen && nextProps.isTargetOpen;
    if (isClosing) {
      return {
        animate: false,
        show: true,
        transform: getInitialTransform(nextProps),
        isClosing: true,
        isTargetOpen: nextProps.isTargetOpen,
      };
    } else if (isOpening) {
      return {
        isOpening: true,
        isTargetOpen: nextProps.isTargetOpen,
      };
    } else {
      return {
        isClosing: false,
        isOpening: false,
        isTargetOpen: nextProps.isTargetOpen,
      };
    }
  }

  componentDidUpdate() {
    if (this.state.isOpening) {
      this.beginOpenAnimation();
    } else if (this.state.isClosing) {
      this.beginCloseAnimation();
    }
  }

  beginOpenAnimation = () => {
    this.setState({ isOpening: false, show: true });
  };

  beginCloseAnimation = () => {
    this.setState({ isClosing: false, animate: true, transform: null }, () =>
      setTimeout(this.finishCloseAnimation.bind(this), ANIMATION_DURATION)
    );
  };

  finishCloseAnimation() {
    this.setState({ animate: false });
  }

  render() {
    const {
      children,
      className,
      instructions,
      isImgLoaded,
      onClick,
      hidden,
      text = 'start',
      autoPlay,
      showButton
    } = this.props;
    const { animate, show, transform } = this.state;

    const renderStartButton = () => {
      if (autoPlay && !showButton) {
        return null;
      } else {
        return (
          <button className="btn btn-large mb0 btn-ff-base" type="button" onClick={onClick}>
            {tcap(text)}
          </button>
        )
      }
    }
    return (
      <div
        className={classnames('pos-r d-ib', className, { 'z-10': animate })}
        style={{
          visibility: show ? 'visible' : 'hidden',
          transition: animate ? 'all .5s ease' : null,
          transform,
          transformOrigin: '0 0',
        }}
      >
        {children}
        <MiniCurtain
          hidden={hidden}
          className={classnames({
            'fadeIn anim anim-duration-5 anim-delay-1': animate,
          })}
        >
          {instructions && <p className="c-white fs-14">{instructions}</p>}
          {isImgLoaded ? renderStartButton() : (
            <p className="c-white">{tcap('loading')}</p>
          )}
        </MiniCurtain>
      </div>
    );
  }
}

Prompt.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  instructions: PropTypes.string,
  isImgLoaded: PropTypes.bool,
  isTargetOpen: PropTypes.bool,
  onClick: PropTypes.func,
  promptBbox: PropTypes.object,
  style: PropTypes.object,
  text: PropTypes.string,
  zoomedImg: PropTypes.object,
};

export default Prompt;

export function getInitialTransform({ promptBbox, zoomedImg }) {
  if (!zoomedImg) return '';
  const zoomedBbox = zoomedImg.getBoundingClientRect();
  const { matrix } = flipInvert(zoomedBbox, promptBbox);
  return matrix;
}
